<template>
  <div id="paypal_button_container">
  </div>
</template>
<script>
import { loadScript } from '@paypal/paypal-js';
import axios from 'axios';
import { apiUrl, paypalClientId } from '@/constants';

export default {
  data() {
    return {
      clientId: paypalClientId,
    };
  },
  name: 'Paypal',
  props: {
    paypalStatus: {
      type: Array,
      required: true,
    },
    baseAmount: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
    merchantId: {
      type: String,
      required: true,
    },
  },
  computed: {
    disableFunding() {
      if (this.paypalStatus.find(el => el === 'paylater')) {
        return ['card'];
      }
      return ['card', 'paylater'];
    },
    enableFunding() {
      if (this.paypalStatus) {
        return this.paypalStatus;
      }
      return ['paypal'];
    },
  },
  async mounted() {
    try {
      const paypal = await loadScript({
        clientId: this.clientId,
        debug: false,
        dataPartnerAttributionId: 'PAYARC_PSP_PPCP',
        enableFunding: this.enableFunding,
        disableFunding: this.disableFunding,
        // buyerCountry: 'US',
        merchantId: this.merchantId,
      });

      if (paypal) {
        // Initialize the PayPal buttons
        await paypal
          .Buttons({
            createOrder: (data, actions) => axios.post(`${apiUrl}/orders/paypal/`, {
              order_id: this.orderId,
              amount: this.baseAmount,
            }, {
              headers: {
                Authorization: `Bearer ${this.token}`,
                'Content-Type': 'application/json',
              },
            }).then(res => res.data.data.paypal_order_id)
              .catch(error => this.$emit('paypal-payment-error')),
            onApprove: async (data, actions) => {
              this.$emit('paypal-payment-success');
            },
            onError:
              (error) => {
                this.$emit('paypal-payment-error');
              },
          })
          .render('#paypal_button_container');
      }
    } catch (error) {
      console.error('Failed to load PayPal JS SDK or render buttons:', error);
    }
  },
  methods: {},
};
</script>
<style scoped>
#paypal_button_container {
  margin-bottom: 14px;
}
</style>
